module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about",
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb1)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb1, 'hb1')
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "about__bottom"
  }, [_c('div', {
    staticClass: "about__inner"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb2)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb2, 'hb2')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb3)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb3, 'hb3')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb4)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb4, 'hb4')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb5)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb5, 'hb5')
      }
    }
  }) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "carouse__mobile carusieal-abaut"
  }, [_c('v-carousel', {
    staticClass: "carouse ",
    attrs: {
      "hide-delimiters": ""
    }
  }, [_c('v-carousel-item', [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb2)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb2, 'hb2')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-carousel-item', [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb3)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb3, 'hb3')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-carousel-item', [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb4)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb4, 'hb4')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-carousel-item', [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb5)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb5, 'hb5')
      }
    }
  }) : _vm._e()])], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "text_nark"
  }, [(_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb6)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb6, 'hb6')
      }
    }
  }) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about__top"
  }, [_c('div', {
    staticClass: "about__titler"
  }, [_vm._v("Наши специалисты")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10711bb5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About/index.vue
// module id = 124
// module chunks = 2